import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import { logoutUser } from "../actions/AuthAction";
import { DATA_DISABILITAS } from "../utils";
import axios from "axios";
import swal from "sweetalert";

function Indikator(props) {
  const [dataDisabilitas, setDataDisabilitas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState({
    nik: "",
    nama: "",
    gender: "",
    tmp_lahir: "",
    tgl_lahir: "",
    jenis_disabilitas: "",
    rekam: "",
    alamat: "",
    rt: "",
    rw: "",
    dusun: "",
    desa: "",
    kecamatan: "",
  });
  const [isEdit, setIsEdit] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [showDetailColumns, setShowDetailColumns] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      // User data stored but not used in this component
      // setCurrentUser(JSON.parse(user));
    } else {
      logoutUser(history);
    }
    fetchDataDisabilitas();
  }, [history]);

  const fetchDataDisabilitas = async () => {
    try {
      setLoading(true);
      const response = await axios.get(DATA_DISABILITAS);
      if (response.data.success) {
        setDataDisabilitas(response.data.data);
      } else {
        swal("Gagal", "Gagal mengambil data disabilitas", "error");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      swal("Gagal", "Gagal mengambil data disabilitas", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const resetForm = () => {
    setFormData({
      nik: "",
      nama: "",
      gender: "",
      tmp_lahir: "",
      tgl_lahir: "",
      jenis_disabilitas: "",
      rekam: "",
      alamat: "",
      rt: "",
      rw: "",
      dusun: "",
      desa: "",
      kecamatan: "",
    });
  };

  const openAddModal = () => {
    setIsEdit(false);
    resetForm();
    setModalOpen(true);
  };

  const openEditModal = (data) => {
    setIsEdit(true);
    setSelectedData(data);
    setFormData({
      nik: data.nik || "",
      nama: data.nama || "",
      gender: data.gender || "",
      tmp_lahir: data.tmp_lahir || "",
      tgl_lahir: data.tgl_lahir || "",
      jenis_disabilitas: data.jenis_disabilitas || "",
      rekam: data.rekam || "",
      alamat: data.alamat || "",
      rt: data.rt || "",
      rw: data.rw || "",
      dusun: data.dusun || "",
      desa: data.desa || "",
      kecamatan: data.kecamatan || "",
    });
    setEditModalOpen(true);
  };

  const openDeleteModal = (data) => {
    setSelectedData(data);
    setDeleteModalOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingSubmit(true);

    try {
      if (isEdit) {
        // Update data
        const response = await axios.put(
          `${DATA_DISABILITAS}${selectedData.id}`,
          formData
        );
        if (response.data.success) {
          swal("Sukses", "Data disabilitas berhasil diupdate", "success");
          setEditModalOpen(false);
          fetchDataDisabilitas();
        } else {
          swal("Gagal", "Gagal mengupdate data disabilitas", "error");
        }
      } else {
        // Add new data
        const response = await axios.post(DATA_DISABILITAS, formData);
        if (response.data.success) {
          swal("Sukses", "Data disabilitas berhasil ditambahkan", "success");
          setModalOpen(false);
          resetForm();
          fetchDataDisabilitas();
        } else {
          swal("Gagal", "Gagal menambahkan data disabilitas", "error");
        }
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      swal("Gagal", "Terjadi kesalahan saat menyimpan data", "error");
    } finally {
      setLoadingSubmit(false);
    }
  };

  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `${DATA_DISABILITAS}${selectedData.id}`
      );
      if (response.data.success) {
        swal("Sukses", "Data disabilitas berhasil dihapus", "success");
        setDeleteModalOpen(false);
        fetchDataDisabilitas();
      } else {
        swal("Gagal", "Gagal menghapus data disabilitas", "error");
      }
    } catch (error) {
      console.error("Error deleting data:", error);
      swal("Gagal", "Terjadi kesalahan saat menghapus data", "error");
    }
  };

  const filteredData = dataDisabilitas.filter(
    (item) =>
      item.nik?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.nama?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const jenisDisabilitasOptions = [
    "DISABILITAS NETRA/BUTA",
    "DISABILITAS MENTAL/JIWA",
    "DISABILITAS FISIK",
    "DISABILITAS FISIK DAN MENTAL",
    "DISABILITAS RUNGU/WICARA",
    "DISABILITAS LAINNYA",
  ];

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Data Disabilitas</CardTitle>
                <Button
                  color="primary"
                  className="float-right"
                  onClick={openAddModal}
                >
                  Tambah Data Disabilitas
                </Button>
              </CardHeader>
              <CardBody>
                {/* Search Bar */}
                <Row className="mb-3">
                  <Col md="6">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="tim-icons icon-zoom-split-in"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Cari berdasarkan NIK atau Nama..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </InputGroup>
                  </Col>
                  <Col md="6" className="text-right">
                    <Button
                      color="secondary"
                      size="sm"
                      onClick={() => setShowDetailColumns(!showDetailColumns)}
                    >
                      <i className="tim-icons icon-settings"></i>
                      {showDetailColumns
                        ? " Sembunyikan Detail"
                        : " Tampilkan Detail"}
                    </Button>
                  </Col>
                </Row>

                {loading ? (
                  <div className="text-center">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <Table className="tablesorter" responsive>
                    <thead className="text-primary">
                      <tr>
                        <th style={{ minWidth: "50px" }}>No</th>
                        <th style={{ minWidth: "150px" }}>NIK</th>
                        <th style={{ minWidth: "200px" }}>Nama</th>
                        <th style={{ minWidth: "100px" }}>Gender</th>
                        {showDetailColumns && (
                          <>
                            <th style={{ minWidth: "120px" }}>Tempat Lahir</th>
                            <th style={{ minWidth: "120px" }}>Tanggal Lahir</th>
                          </>
                        )}
                        <th style={{ minWidth: "200px" }}>Jenis Disabilitas</th>
                        <th style={{ minWidth: "100px" }}>Status Rekam</th>
                        {showDetailColumns && (
                          <>
                            <th style={{ minWidth: "80px" }}>RT</th>
                            <th style={{ minWidth: "80px" }}>RW</th>
                            <th style={{ minWidth: "150px" }}>Dusun</th>
                          </>
                        )}
                        <th style={{ minWidth: "150px" }}>Desa</th>
                        <th style={{ minWidth: "150px" }}>Kecamatan</th>
                        {showDetailColumns && (
                          <th style={{ minWidth: "200px" }}>Alamat</th>
                        )}
                        <th style={{ minWidth: "100px" }}>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td style={{ fontWeight: "bold", color: "#007bff" }}>
                            {item.nik || "-"}
                          </td>
                          <td>{item.nama || "-"}</td>
                          <td>
                            {item.gender === "Lk"
                              ? "Laki-laki"
                              : item.gender === "Pr"
                              ? "Perempuan"
                              : item.gender || "-"}
                          </td>
                          {showDetailColumns && (
                            <>
                              <td>{item.tmp_lahir || "-"}</td>
                              <td>
                                {item.tgl_lahir
                                  ? new Date(item.tgl_lahir).toLocaleDateString(
                                      "id-ID"
                                    )
                                  : "-"}
                              </td>
                            </>
                          )}
                          <td>{item.jenis_disabilitas || "-"}</td>
                          <td>
                            <span
                              className={`badge badge-${
                                item.rekam === "Sudah" ? "success" : "warning"
                              }`}
                            >
                              {item.rekam || "Belum"}
                            </span>
                          </td>
                          {showDetailColumns && (
                            <>
                              <td>{item.rt || "-"}</td>
                              <td>{item.rw || "-"}</td>
                              <td>{item.dusun || "-"}</td>
                            </>
                          )}
                          <td>{item.desa || "-"}</td>
                          <td>{item.kecamatan || "-"}</td>
                          {showDetailColumns && (
                            <td>
                              <div
                                style={{
                                  maxWidth: "200px",
                                  wordWrap: "break-word",
                                }}
                              >
                                {item.alamat || "-"}
                              </div>
                            </td>
                          )}
                          <td>
                            <Button
                              color="info"
                              size="sm"
                              onClick={() => openEditModal(item)}
                              className="mr-1"
                            >
                              <i className="tim-icons icon-pencil"></i>
                            </Button>
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => openDeleteModal(item)}
                            >
                              <i className="tim-icons icon-simple-remove"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}

                {!loading && filteredData.length === 0 && (
                  <Alert color="info">
                    {searchTerm
                      ? "Tidak ada data yang sesuai dengan pencarian"
                      : "Belum ada data disabilitas"}
                  </Alert>
                )}

                {!loading && filteredData.length > 0 && (
                  <div className="mt-3">
                    <small className="text-muted">
                      Menampilkan {filteredData.length} dari{" "}
                      {dataDisabilitas.length} data disabilitas
                      {searchTerm && ` (hasil pencarian: "${searchTerm}")`}
                    </small>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal Tambah Data */}
        <Modal
          isOpen={modalOpen}
          toggle={() => setModalOpen(!modalOpen)}
          size="lg"
        >
          <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
            Tambah Data Disabilitas
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="nik">NIK *</Label>
                    <Input
                      type="text"
                      name="nik"
                      value={formData.nik}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="nama">Nama Lengkap *</Label>
                    <Input
                      type="text"
                      name="nama"
                      value={formData.nama}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="gender">Jenis Kelamin *</Label>
                    <Input
                      type="select"
                      name="gender"
                      value={formData.gender}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Pilih Jenis Kelamin</option>
                      <option value="Lk">Laki-laki</option>
                      <option value="Pr">Perempuan</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="jenis_disabilitas">Jenis Disabilitas *</Label>
                    <Input
                      type="select"
                      name="jenis_disabilitas"
                      value={formData.jenis_disabilitas}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Pilih Jenis Disabilitas</option>
                      {jenisDisabilitasOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="tmp_lahir">Tempat Lahir</Label>
                    <Input
                      type="text"
                      name="tmp_lahir"
                      value={formData.tmp_lahir}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="tgl_lahir">Tanggal Lahir</Label>
                    <Input
                      type="date"
                      name="tgl_lahir"
                      value={formData.tgl_lahir}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="rekam">Status Rekam</Label>
                    <Input
                      type="select"
                      name="rekam"
                      value={formData.rekam}
                      onChange={handleInputChange}
                    >
                      <option value="">Pilih Status</option>
                      <option value="Sudah">Sudah</option>
                      <option value="Belum">Belum</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="desa">Desa *</Label>
                    <Input
                      type="text"
                      name="desa"
                      value={formData.desa}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="kecamatan">Kecamatan *</Label>
                    <Input
                      type="text"
                      name="kecamatan"
                      value={formData.kecamatan}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="dusun">Dusun</Label>
                    <Input
                      type="text"
                      name="dusun"
                      value={formData.dusun}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="rt">RT</Label>
                    <Input
                      type="text"
                      name="rt"
                      value={formData.rt}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="rw">RW</Label>
                    <Input
                      type="text"
                      name="rw"
                      value={formData.rw}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <FormGroup>
                <Label for="alamat">Alamat Lengkap</Label>
                <Input
                  type="textarea"
                  name="alamat"
                  value={formData.alamat}
                  onChange={handleInputChange}
                  rows="3"
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setModalOpen(!modalOpen)}>
              Batal
            </Button>
            <Button
              color="primary"
              onClick={handleSubmit}
              disabled={loadingSubmit}
            >
              {loadingSubmit ? "Menyimpan..." : "Simpan"}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Edit Data */}
        <Modal
          isOpen={editModalOpen}
          toggle={() => setEditModalOpen(!editModalOpen)}
          size="lg"
        >
          <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>
            Edit Data Disabilitas
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="nik">NIK *</Label>
                    <Input
                      type="text"
                      name="nik"
                      value={formData.nik}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="nama">Nama Lengkap *</Label>
                    <Input
                      type="text"
                      name="nama"
                      value={formData.nama}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="gender">Jenis Kelamin *</Label>
                    <Input
                      type="select"
                      name="gender"
                      value={formData.gender}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Pilih Jenis Kelamin</option>
                      <option value="Lk">Laki-laki</option>
                      <option value="Pr">Perempuan</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="jenis_disabilitas">Jenis Disabilitas *</Label>
                    <Input
                      type="select"
                      name="jenis_disabilitas"
                      value={formData.jenis_disabilitas}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Pilih Jenis Disabilitas</option>
                      {jenisDisabilitasOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="tmp_lahir">Tempat Lahir</Label>
                    <Input
                      type="text"
                      name="tmp_lahir"
                      value={formData.tmp_lahir}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="tgl_lahir">Tanggal Lahir</Label>
                    <Input
                      type="date"
                      name="tgl_lahir"
                      value={formData.tgl_lahir}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="rekam">Status Rekam</Label>
                    <Input
                      type="select"
                      name="rekam"
                      value={formData.rekam}
                      onChange={handleInputChange}
                    >
                      <option value="">Pilih Status</option>
                      <option value="Sudah">Sudah</option>
                      <option value="Belum">Belum</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="desa">Desa *</Label>
                    <Input
                      type="text"
                      name="desa"
                      value={formData.desa}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="kecamatan">Kecamatan *</Label>
                    <Input
                      type="text"
                      name="kecamatan"
                      value={formData.kecamatan}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="dusun">Dusun</Label>
                    <Input
                      type="text"
                      name="dusun"
                      value={formData.dusun}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="rt">RT</Label>
                    <Input
                      type="text"
                      name="rt"
                      value={formData.rt}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="rw">RW</Label>
                    <Input
                      type="text"
                      name="rw"
                      value={formData.rw}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <FormGroup>
                <Label for="alamat">Alamat Lengkap</Label>
                <Input
                  type="textarea"
                  name="alamat"
                  value={formData.alamat}
                  onChange={handleInputChange}
                  rows="3"
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => setEditModalOpen(!editModalOpen)}
            >
              Batal
            </Button>
            <Button
              color="primary"
              onClick={handleSubmit}
              disabled={loadingSubmit}
            >
              {loadingSubmit ? "Mengupdate..." : "Update"}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Konfirmasi Hapus */}
        <Modal
          isOpen={deleteModalOpen}
          toggle={() => setDeleteModalOpen(!deleteModalOpen)}
        >
          <ModalHeader toggle={() => setDeleteModalOpen(!deleteModalOpen)}>
            Konfirmasi Hapus
          </ModalHeader>
          <ModalBody>
            Apakah Anda yakin ingin menghapus data disabilitas{" "}
            <strong>{selectedData?.nama}</strong> dengan NIK{" "}
            <strong>{selectedData?.nik}</strong>?
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => setDeleteModalOpen(!deleteModalOpen)}
            >
              Batal
            </Button>
            <Button color="danger" onClick={handleDelete}>
              Hapus
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

export default Indikator;
